import React, { useState, useCallback } from 'react';
import { Modal, Group, Button, PasswordInput, Alert, Space, LoadingOverlay } from '@mantine/core';
import * as App from "./../../model/App";

interface IChangePasswordModalProps { 
    visible: boolean;
    onClose: () => void;
}

export default function ChangePasswordModal(props: IChangePasswordModalProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [passwordCurrent, setPasswordCurrent] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>("");
    const [errorMessage, setErrorMessage] = useState<string>("");

    const clear = useCallback(() => {
        setPasswordCurrent("");
        setNewPassword("");
        setNewPasswordConfirm("");
        setErrorMessage("");
    }, [setPasswordCurrent, setNewPassword, setNewPasswordConfirm, setErrorMessage]);

    return (
        <Modal opened={props.visible} onClose={props.onClose} title="Update Email">
            <LoadingOverlay visible={isLoading} />

            <PasswordInput value={passwordCurrent} placeholder="Current Password" my={10}
                onChange={(event) => { setPasswordCurrent(event.target.value); }} 
            />

            <PasswordInput value={newPassword} placeholder="New Password" my={10}
                onChange={(event) => { setNewPassword(event.target.value); }} 
            />

            <PasswordInput value={newPasswordConfirm} placeholder="New Password, again" my={10}
                onChange={(event) => { setNewPasswordConfirm(event.target.value); }} 
            />

            <Group position="apart">
                <Button onClick={() => {
                    setErrorMessage("");
                    if (newPassword !== newPasswordConfirm) {
                        setErrorMessage("Emails do not match");
                        return;
                    }

                    setIsLoading(true);
                    App.Firebase.Auth.changeCurrentUserPassword(passwordCurrent, newPassword).then(() => {
                        setIsLoading(false);
                        clear();
                        props.onClose();
                    }).catch((error) => {
                        setIsLoading(false);
                        setErrorMessage(error.message);
                    });
                }}
                >Update Password</Button>

                <Button sx={(theme) => ({ 
                    backgroundColor: theme.colors.gray[4], color: "black", "&:hover": { color: "black", backgroundColor: theme.colors.gray[5] } })} 
                    onClick={() => { clear(); props.onClose(); }}
                >Cancel</Button>
            </Group>

            <Space h="md" />
            {errorMessage && <Alert color="red" title="Error">{errorMessage}</Alert>}
        </Modal>
    );
}